/**
 * Converts a raw time value (in seconds) to rounded minutes.
 * Values under 60 seconds are floored to 1 minute.
 */
export const roundToMinutes = (seconds: number): number =>
    seconds < 60 ? 1 : Math.round(seconds / 60);
